import { evolve } from 'remeda';

import {
    type NewRTElement,
    type NewUnityRTElement,
    type RTElement,
    type UnityRTElement,
} from '@@api/services/rtelements/schemas';
import deserializeState from '@@plate/serialization/unity/utils/deserializeState';
import serializeState from '@@plate/serialization/unity/utils/serializeState';

export const deserializeRTElement = (entity: UnityRTElement): RTElement =>
    evolve(entity, {
        element: deserializeState,
    });

export const serializeRTElement = (
    entity: RTElement | NewRTElement,
): UnityRTElement | NewUnityRTElement =>
    evolve(entity, {
        element: serializeState,
    });
